export default "__VITE_ASSET__Dx$IOOPG__"